export default {
  setCurrentPatient (state, payload) {
    state.currentPatient = payload
    localStorage.setItem('current-patient', JSON.stringify(state.currentPatient))
  }
}
